// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DOAG","name":"styles_name__3CHae","phone":"styles_phone__24kQH"};